export const SET_CLIENTINFO = "SET_CLIENTINFO";
export const CLEAR_CLIENTINFO = "CLEAR_CLIENTINFO";